module.exports = __webpack_public_path__ + "img/ms_b3_img1.511fd103.png";